import { Box, useTheme } from '@mui/material';
import { Suspense } from 'react';
import { Outlet } from 'react-router';

import { Loader } from '@/modules/common/components';

const MaterialityAssessmentSurveyLayout = () => {
  const theme = useTheme();
  return (
    <Box
      component="div"
      sx={{
        display: 'flex',
      }}
    >
      <Box
        component="main"
        sx={{
          position: 'relative',
          overflow: 'hidden',
          flexGrow: 1,
          minHeight: '100vh',
          padding: theme.spacing(3, 4, 3, 4),
        }}
      >
        <Suspense fallback={<Loader />}>
          <Outlet />
        </Suspense>
      </Box>
    </Box>
  );
};

export default MaterialityAssessmentSurveyLayout;
